import { REWARD_STATUS } from '../../../shared/models/reward-status.enum';

/**
 * Statuses that should be treated as disabled in the UI for version 2.
 */
export const DISABLED_STATUSES = new Set<REWARD_STATUS>([
  REWARD_STATUS.ComingSoon,
  REWARD_STATUS.ViewableOnly,
  REWARD_STATUS.SoldOut,
  REWARD_STATUS.LimitReached,
  REWARD_STATUS.NotEnoughPoints,
]);
